// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__xuuRz","box":"WorkspacesBox_box__3AKKT","node":"WorkspacesBox_node__ZY4aJ"};